import { Settings } from "lucide-react";

export function SettingsPage() {
    return (
        <div className="mx-auto max-w-2xl">
            <div className="mb-6 flex items-center gap-3">
                <Settings className="h-5 w-5 text-primary" />
                <h1 className="text-xl font-semibold">Settings</h1>
            </div>
            <div className="rounded-lg border bg-card p-8 text-center shadow-sm">
                <p className="text-muted-foreground">
                    Platform settings will be available in a future release.
                </p>
            </div>
        </div>
    );
}
